/**
 * Created by Ivan on 11.08.2026
 */

const StickersPrizeBar2 = {
    create: function (options) {
        const rewards = new RewardsList(options.reward).listRewards();
        const prizeBar = new PrizeBarComponent({ ...options, prize: false });

        let icon;
        if (rewards.length === 1) {
            icon = rewards[0].getIcon();
        } else if (options.multiPrizeIcon) {
            icon = new cc.Sprite(options.multiPrizeIcon);
        } else {
            icon = new cleverapps.Spine(bundles.prize.jsons.prize_json);
            icon.setAnimation(0, "idle", true);
        }
        cleverapps.UI.fitToBox(icon, options.icon);

        const box = new cc.Node();
        box.setAnchorPoint(0.5, 0.5);
        box.setContentSize(options.icon.width, options.icon.height);
        box.addChild(icon);
        icon.setAlignment({ align: "center" }, { align: "center" });

        if (rewards.length === 1 && rewards[0].type === "units") {
            StickersUnitHelp2.attach(box, rewards[0].value, options.icon.help);
        }
        if (rewards.length !== 1) {
            cleverapps.tooltipManager.create(box, {
                text: Messages.get("Reward"),
                rewards: options.reward,
                location: cleverapps.UI.Tooltip.LOCATION_BELOW,
                size: cleverapps.styles.UI.Tooltip.SIZE.short
            });
        }

        prizeBar.prizeIcon = box;
        box.setAlignment(options.icon.position);
        prizeBar.progressBar.addChild(box);
        box.replaceParentSamePlace(prizeBar);

        return prizeBar;
    },

    setTooltipEnabled: function (prizeBar, enabled) {
        const icon = prizeBar.prizeIcon;
        if (icon.tooltipHandler) {
            icon.tooltipHandler.setEnabled(enabled);
        }
    },

    setIconFull: function (prizeBar, onCollect) {
        const icon = prizeBar.prizeIcon;
        if (!icon || icon.clickHandler) {
            return;
        }

        cleverapps.tooltipManager.remove(icon);

        StandartAnimations.rays(icon, { skin: "white" }).setTimeScale(2);
        FingerView.hintTap(icon, {
            delay: 1.6,
            scale: cleverapps.styles.PrizeBarComponent.prize.finger.scale
        });
        cleverapps.UI.applyHover(icon);
        icon.clickHandler = cleverapps.UI.onClick(icon, () => {
            icon.runAction(new cc.Sequence(
                StandartAnimations.disappear(icon),
                new cc.CallFunc(onCollect)
            ));
        });
    }
};
